import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
import { Activity } from '../../../sdk/models';
import { ActivityApi } from '../../../sdk/services/custom';
import { FormBuilder, FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from 'ng-formly';
import { activityFields } from '../../../formfields';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import * as _ from "lodash";
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'activity-widget',
    templateUrl: './activity.component.html',
    providers: [ActivityApi],
    styleUrls: ['./activity.component.scss']

})

export class ActivityWidgetComponent implements OnInit, OnDestroy {
    @Input() id: string;
    @Input() showTask: boolean;
    @Input() showCall: boolean;
    @Input() showEvent: boolean;
    @Input() entityrecordid: any;
    @Input() entityid: any;
    subscriptions: any = [];
    @Output() onChanged: EventEmitter<Activity> = new EventEmitter(true);
    showCardWrapper = true;
    formTask: FormGroup;
    currentuser;
    activityFields: Array<FormlyFieldConfig> = [];
    activity: Activity = new Activity();
    notifyOptions = PlatformApp.getNotificationOptions();

    @Input() disableCardWrapper: boolean;
    @ViewChild('childModal') public childModal: ModalDirective;

    public showChildModal(): void {
        this.childModal.show();
    }

    public hideChildModal(): void {
        if (this.formTask && this.formTask['subscriptions'])
            this.formTask['subscriptions'].forEach(s => { s.unsubscribe(); });
        if (this.formTask)
            this.formTask = this.fb.group({});
        this.childModal.hide();
    }

    constructor(private _ActivityApi: ActivityApi,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        private fb: FormBuilder, private _LoopBackAuth: LoopBackAuth) {

    }

    ngOnInit(): void {
        if (this.disableCardWrapper)
            this.showCardWrapper = false;
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.prepareFields('task');
        this.activityFields = activityFields;
        this.formTask = this.fb.group({});
        /*
        TODO
        If we get the entity id , then we need to fetch the entity details and check the related_tasks and related_events that can set for the entity.
        */

    }

    patchOrCreateActivity(activity, type): void {

        if (!activity && !type) {
            return;
        }
        this.subscriptions.push(this._ActivityApi.patchOrCreate(this.prepareItemforSave(activity, type))
            .subscribe((newtask) => {
                console.log('Task Saved');
                this.onChanged.emit(newtask);
            }));
    }

    prepareFields(type) {

        if (type === 'task') {
            this.activity.type = "task";
        } else if (type === 'call') {
            this.activity.type = "call";
        } else if (type === 'visit') {
            this.activity.type = "visit";
        } else if (type === 'event') {
            this.activity.type = "event";
        }
    }

    prepareItemforSave(activity, type) {
        if (activity) {
            if (this.entityid) {
                activity.entityId = this.entityid;
            }
            if (this.entityrecordid) {
                activity.entityrecordId = this.entityrecordid;
            }

            activity.createdby = this.currentuser.id;
            activity.lastupdatedby = this.currentuser.id;
            activity.appId = this.currentuser.appId;
            activity.accountId = this.currentuser.id;
            activity["generatedBy"] = "user";

            if (activity.ActivityDate && activity.ActivityDate < new Date()) {
                activity.Status = "completed";
            } else {
                activity.Status = "open";
            }
            console.log('Status->' + activity.Status);
            if (type === 'task') {
                activity.type = "task";
            } else if (type === 'call') {
                activity.type = "call";
                /*
                To do check the status of the date and mark the status as open or completed
                */


            } else if (type === 'visit') {
                activity.type = "visit";
                /*
               To do check the status of the date and mark the status as open or completed
               */
            } else if (type === 'event') {
                activity.type = "event";
                /*
               To do check the status of the date and mark the status as open or completed
               */
            }
        }

        return activity;
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/activity/activity.component.ts